// extracted by mini-css-extract-plugin
export default {"container":"LKzNbr6ZumUHm0dK191_","customerInfo":"ZPTJRdppP4Tdanq7Bd21"};